import { createApi } from '@reduxjs/toolkit/query/react';
import { createAuthenticatedBaseQuery, API_BASE_URLS } from '../../../services/shared';
import { VERIFICATION_TAG_TYPES } from './tags';

/**
 * Single base RTK Query API for the Verifications backend (one `createApi` per backend).
 *
 * This is intentionally EMPTY of endpoints — features inject their own endpoints via
 * `verificationsApi.injectEndpoints` in `features/{x}/data/{x}Endpoints.ts`. This api owns the
 * shared concerns that must be singular for the cache to behave correctly:
 *  - the authenticated base query (auth header + verifications base URL),
 *  - the single `tagTypes` registry (see `tags.ts`),
 *  - the one cache space, so request dedup and cross-feature tag invalidation work.
 *
 * Never create a second `createApi` for this backend from within this module — that would fragment
 * the cache. Import this base api by file path (`../../../data/verificationsApi`) from feature
 * endpoint files, not via the `data` barrel, to avoid import cycles.
 */
export const verificationsApi = createApi({
  reducerPath: 'verificationsApi',
  baseQuery: createAuthenticatedBaseQuery(API_BASE_URLS.verifications),
  tagTypes: VERIFICATION_TAG_TYPES,
  endpoints: () => ({}),
});
